import { Component, OnInit, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';
import { MenuService } from '../../../services';

@Component({
  selector: 'app-formly-textarea',
  templateUrl: './formly-text-area.component.html',
  styleUrl: './formly-text-area.component.scss',
  imports: [FormsModule, ReactiveFormsModule, FormlyModule],
})
export class FormlyTextAreaComponent extends FormlyFieldBaseComponent implements OnInit {
  protected readonly menuService = inject(MenuService);

  protected hasScrollbar: boolean;

  constructor() {
    super();

    this.defaultOptions = {
      props: { rows: 5 },
    };
  }

  ngOnInit() {
    if (this.menuService.isReadOnly) {
      this.props.readonly = true;
      this.props.tabindex = -1;
    }
  }

  onKeyUp(event: any) {
    this.hasScrollbar = event.target.clientHeight < event.target.scrollHeight;
  }
}
